import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hb9 from '../components/Hb9';

function Socials() {
    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Archivo+Black&family=Poppins:wght@400;500;600;700&display=swap" rel="stylesheet" />
            <style>{`
        body {
          font-family: 'Poppins', sans-serif;
        }
        .font-archivo-black {
          font-family: 'Archivo Black', sans-serif;
        }
        .font-poppins {
          font-family: 'Poppins', sans-serif;
        }
      `}</style>

            <div className="font-poppins">
                <Header />

                {/* Hero Section */}
                <section className="bg-customBlue text-white p-6 lg:p-16 flex flex-col lg:flex-row items-center">
                    <div className="lg:w-1/2 lg:pr-12">
                        <h1 className="font-archivo-black text-2xl lg:text-5xl font-bold lg:pl-12 uppercase">
                            Onboard <span className="text-customY">Socials</span>
                        </h1>
                        <h2 className="font-poppins mt-4 text-xl lg:text-2xl font-semibold lg:pl-12">
                            Professional Profile Development & Personal Branding
                        </h2>
                        <p className="font-poppins mt-4 lg:mt-6 text-lg leading-relaxed lg:pl-12">
                            Onboard Socials is the professional branding division of Onboard HRServices, focused on building strong, market-ready candidate profiles.
                        </p>
                        <p className="font-poppins mt-2 text-lg leading-relaxed lg:pl-12">
                            We support individuals and institutions with structured resume development, LinkedIn profile optimization, and large-scale resume projects.
                        </p>
                    </div>
                    <div className="mt-8 lg:mt-0 lg:w-1/2 flex justify-center">
                        <div className="relative w-full max-w-lg h-72 lg:h-[500px] rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10 group">
                            <div className="absolute inset-0 bg-gradient-to-t from-customBlue/60 to-transparent z-10"></div>
                            <img
                                src={require("../assets/onboard_socials_hero.png")}
                                alt="Professional Branding"
                                className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                            />
                            <div className="absolute bottom-6 left-6 z-20">
                                <span className="bg-customY text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-widest">Premium Services</span>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Our Approach Banner */}
                <section className="bg-customY text-white py-12 px-6 md:px-40 flex flex-col md:flex-row items-center justify-between">
                    <div className="w-full md:w-1/2 mb-6 md:mb-0">
                        <h2 className="font-archivo-black text-3xl md:text-4xl font-bold">
                            OUR <br /> APPROACH
                        </h2>
                    </div>
                    <div className="w-full md:w-1/2">
                        <p className="font-poppins text-lg leading-relaxed italic">
                            "Our approach combines recruitment insight, industry alignment, and keyword optimization to ensure profiles meet current hiring standards."
                        </p>
                    </div>
                </section>

                {/* Services Section */}
                <section className="py-20 px-6 lg:px-16 bg-gray-50">
                    <div className="max-w-7xl mx-auto">
                        <h2 className="font-archivo-black text-3xl lg:text-4xl text-customBlue text-center mb-16 uppercase">
                            Our Services
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                            {/* Resume Development */}
                            <div className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-customY hover:transform hover:-translate-y-2 transition-all duration-300">
                                <div className="text-customY mb-4">
                                    <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-1 7V3.5L18.5 9H13zM16 11h-8v-2h8v2zm0 4h-8v-2h8v2zm-3 4h-5v-2h5v2z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-customBlue mb-4">Resume Development</h3>
                                <p className="text-gray-600 mb-6">
                                    We create professionally structured, ATS-aligned resumes tailored to industry requirements and career level.
                                </p>
                                <ul className="space-y-4 text-gray-700 font-medium">
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customY/10 p-2 rounded-lg text-customY">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                                        </div>
                                        One-page and two-page resumes
                                    </li>
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customY/10 p-2 rounded-lg text-customY">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>
                                        </div>
                                        Executive resume writing
                                    </li>
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customY/10 p-2 rounded-lg text-customY">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path></svg>
                                        </div>
                                        Industry-specific customization
                                    </li>
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customY/10 p-2 rounded-lg text-customY">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                        </div>
                                        International resume formats
                                    </li>
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customY/10 p-2 rounded-lg text-customY">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path></svg>
                                        </div>
                                        Enhancement & restructuring
                                    </li>
                                </ul>
                            </div>

                            {/* LinkedIn Branding */}
                            <div className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-customBlue hover:transform hover:-translate-y-2 transition-all duration-300">
                                <div className="text-customBlue mb-4">
                                    <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-customBlue mb-4">LinkedIn Branding</h3>
                                <p className="text-gray-600 mb-6">
                                    We optimize LinkedIn profiles to improve visibility, positioning, and professional credibility.
                                </p>
                                <ul className="space-y-4 text-gray-700 font-medium">
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customBlue/10 p-2 rounded-lg text-customBlue">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"></path></svg>
                                        </div>
                                        Headline & summary optimization
                                    </li>
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customBlue/10 p-2 rounded-lg text-customBlue">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                                        </div>
                                        Experience section restructuring
                                    </li>
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customBlue/10 p-2 rounded-lg text-customBlue">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
                                        </div>
                                        Keyword alignment for search
                                    </li>
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customBlue/10 p-2 rounded-lg text-customBlue">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
                                        </div>
                                        Personal brand positioning
                                    </li>
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customBlue/10 p-2 rounded-lg text-customBlue">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                        </div>
                                        Consistency & clarity review
                                    </li>
                                </ul>
                            </div>

                            {/* Bulk Resume Projects */}
                            <div className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-customY hover:transform hover:-translate-y-2 transition-all duration-300">
                                <div className="text-customY mb-4">
                                    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-customBlue mb-4">Bulk projects</h3>
                                <p className="text-gray-600 mb-6">
                                    We manage structured, high-volume resume development projects for various institutions.
                                </p>
                                <ul className="space-y-4 text-gray-700 font-medium">
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customY/10 p-2 rounded-lg text-customY">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path></svg>
                                        </div>
                                        Educational institutions
                                    </li>
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customY/10 p-2 rounded-lg text-customY">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path></svg>
                                        </div>
                                        Skill development centers
                                    </li>
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customY/10 p-2 rounded-lg text-customY">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path></svg>
                                        </div>
                                        Aviation & hospitality academies
                                    </li>
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customY/10 p-2 rounded-lg text-customY">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                                        </div>
                                        Corporate outplacement
                                    </li>
                                    <li className="flex items-center gap-3">
                                        <div className="bg-customY/10 p-2 rounded-lg text-customY">
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path></svg>
                                        </div>
                                        Workforce development
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Who We Serve Section */}
                <section className="bg-customBlue py-20 px-6 lg:px-16 text-white text-center">
                    <h2 className="font-archivo-black text-3xl lg:text-4xl mb-12 uppercase">
                        Who We Serve
                    </h2>
                    <div className="flex flex-wrap justify-center gap-6">
                        {[
                            "Students & Graduates",
                            "Mid-level Professionals",
                            "Senior Executives",
                            "Career Transition Candidates",
                            "Institutions & HR Departments"
                        ].map((item, index) => (
                            <div key={index} className="bg-white/10 backdrop-blur-md px-8 py-4 rounded-full border border-white/20 font-semibold text-lg">
                                {item}
                            </div>
                        ))}
                    </div>
                </section>

                {/* Core methodology */}
                <section className="py-20 px-6 lg:px-40 bg-white">
                    <div className="flex flex-col md:flex-row gap-16 items-center">
                        <div className="w-full md:w-1/2">
                            <h2 className="font-archivo-black text-3xl lg:text-4xl text-customBlue mb-8 uppercase">
                                Our Methodology
                            </h2>
                            <p className="text-gray-700 text-lg mb-8">
                                Being backed by <span className="font-bold text-customBlue">Onboard HRServices</span> allows us to align profile development with real hiring expectations. Every profile is developed using:
                            </p>
                            <ul className="space-y-4">
                                {[
                                    "Recruitment-backed insight",
                                    "Industry-relevant positioning",
                                    "ATS-compliant formatting",
                                    "Structured content strategy",
                                    "Quality review standards"
                                ].map((item, index) => (
                                    <li key={index} className="flex items-center text-lg font-medium text-gray-800">
                                        <span className="w-8 h-8 rounded-full bg-customY text-white flex items-center justify-center mr-4 text-sm font-bold">{index + 1}</span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="w-full md:w-1/2 bg-customY/5 p-8 rounded-2xl border-2 border-dashed border-customY/20">
                            <div className="text-center">
                                <h3 className="text-2xl font-bold text-customBlue mb-4">Connect With Us</h3>
                                <p className="text-gray-600 mb-8">
                                    For individual consultations or bulk projects, please contact our team to discuss your requirements.
                                </p>
                                <a
                                    href="mailto:socials@onboardhrservices.com"
                                    className="bg-customBlue text-white px-10 py-4 font-bold rounded-lg shadow-xl hover:bg-opacity-90 transition-all uppercase tracking-wider inline-block text-center cursor-pointer relative z-10"
                                >
                                    Contact Our Team
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Hb9 Section */}
                <Hb9 />

                <Footer />
            </div>
        </>
    );
}

export default Socials;
